import { StoreValue } from 'antd/lib/form/interface';
import { TFunction } from 'i18next';

export const validateOptionalTranslation = ({
  t,
  fieldName,
  getFieldValue,
}: {
  fieldName: string;
  getFieldValue: (name: any) => StoreValue;
  t: TFunction;
}) => {
  const { en, ...rest } = getFieldValue([fieldName]);

  // If there's no value in English but there's value in other languages, require English
  if (Object.values(rest).some(Boolean) && !en) {
    return Promise.reject(new Error(t('patient:validations.default_translation')));
  }
  return Promise.resolve();
};
